import React from 'react';
import { IconMoon, IconSun, IconGithubLogo, IconKey } from '@douyinfe/semi-icons';
import { useTheme, useSetTheme } from '../context/Theme';

const AppHeader = () => {
  const theme = useTheme();
  const setTheme = useSetTheme();
  const isDark = theme === 'dark';

  return (
    <header className="app-header">
      <div className="app-brand">
        <span className="app-brand-logo">
          <IconKey size="small" />
        </span>
        小忆API
      </div>
      <div className="app-header-actions">
        {process.env.REACT_APP_SHOW_ICONGITHUB === 'true' && (
          <button
            className="icon-btn"
            title="GitHub"
            aria-label="GitHub"
            onClick={() => window.open('https://github.com/Calcium-Ion/neko-api-key-tool', '_blank')}
          >
            <IconGithubLogo />
          </button>
        )}
        <button
          className="icon-btn"
          title={isDark ? '切换到浅色模式' : '切换到深色模式'}
          aria-label={isDark ? '切换到浅色模式' : '切换到深色模式'}
          onClick={() => setTheme(!isDark)}
        >
          {isDark ? <IconSun /> : <IconMoon />}
        </button>
      </div>
    </header>
  );
};

export default AppHeader;
